module.exports = __webpack_public_path__ + "static/img/zfb.fccae50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zfb.png
// module id = 1oGI
// module chunks = 128